import Translator from '%app/js/common/services/translator';

export default function () {
    return function (text, placeholder, domain) {
        let translated = null;

        if (typeof text !== 'string') {
            translated = text;
        }

        if (typeof Translator !== 'object') {
            translated = text;
        }

        if (typeof placeholder !== 'object') {
            placeholder = {};
        }

        if (typeof domain === 'string' && domain.length !== 0) {
            translated = Translator.trans(text, placeholder, domain);
        } else {
            translated = Translator.trans(text, placeholder);
        }

        return translated;
    };
}
